import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { FileText, FileSpreadsheet, Loader2 } from "lucide-react";

const CRITERI = [
  ["da_rimborsare", "Solo approvate da rimborsare"],
  ["approvate", "Tutte le approvate del mese"],
  ["approvate_inviate", "Approvate più quelle inviate"],
];

export function ReportMensileDialog({ open, onClose, persone = [] }) {
  const [f, setF] = useState({ persona_id: "", mese: new Date().toISOString().slice(0, 7), criterio: "da_rimborsare" });
  const [busy, setBusy] = useState(null);

  const scarica = async (formato) => {
    if (!f.persona_id) return toast.error("Seleziona la persona");
    if (!f.mese) return toast.error("Seleziona il mese");
    setBusy(formato);
    try {
      const res = await api.get("/personale/report-note-spese", { params: { ...f, formato }, responseType: "blob" });
      const nome = (persone.find((p) => p.id === f.persona_id)?.nome || "persona").replace(/[^A-Za-z0-9]+/g, "_");
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = `report_note_spese_${nome}_${f.mese}.${formato === "pdf" ? "pdf" : "xlsx"}`; a.click();
      URL.revokeObjectURL(url);
      toast.success("Report scaricato");
    } catch (e) {
      const msg = e.response?.data instanceof Blob ? JSON.parse(await e.response.data.text()).detail : null;
      toast.error(msg || "Download non riuscito");
    } finally { setBusy(null); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="ns-report-dialog">
        <DialogHeader>
          <DialogTitle>Report mensile per il rimborso</DialogTitle>
          <DialogDescription>Una nota conta nel mese in cui inizia la trasferta o la spesa.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div><Label>Persona</Label>
            <Select value={f.persona_id} onValueChange={(v) => setF({ ...f, persona_id: v })}>
              <SelectTrigger data-testid="ns-report-persona"><SelectValue placeholder="Seleziona" /></SelectTrigger>
              <SelectContent>{persone.map((p) => <SelectItem key={p.id} value={p.id}>{p.nome}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div><Label htmlFor="ns-report-mese">Mese</Label>
            <Input id="ns-report-mese" type="month" value={f.mese} onChange={(e) => setF({ ...f, mese: e.target.value })} data-testid="ns-report-mese" />
          </div>
          <div><Label>Note da includere</Label>
            <Select value={f.criterio} onValueChange={(v) => setF({ ...f, criterio: v })}>
              <SelectTrigger data-testid="ns-report-criterio"><SelectValue /></SelectTrigger>
              <SelectContent>{CRITERI.map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => scarica("excel")} disabled={!!busy} data-testid="ns-report-excel">
            {busy === "excel" ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <FileSpreadsheet className="h-4 w-4 mr-1.5" />}Excel
          </Button>
          <Button onClick={() => scarica("pdf")} disabled={!!busy} data-testid="ns-report-pdf">
            {busy === "pdf" ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <FileText className="h-4 w-4 mr-1.5" />}Scarica PDF
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
